
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[tag]",
      function () {
        return require("private-next-pages/topics/[tag].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[tag]"])
      });
    }
  